exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selRow[data-v-6c7476a6]{background-color:#fbff94}.rowBoxShadow[data-v-6c7476a6]{box-shadow:0 -2px 3px rgb(126 72 156/15%)}.tdGradient[data-v-6c7476a6]{background:linear-gradient(hsla(0,0%,91%,.4),#fff)}.tdGradient2[data-v-6c7476a6]{background:linear-gradient(hsla(0,0%,91%,.4),#fff,#fff)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c7476a6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListTabagheBandiAmaliyati/Components/ShowTableTabagheBandiAmaliyati.vue
// module id = 619
// module chunks = 0